import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UserService } from "../../@core/api/users.service"
import { MessageHandlerService } from "../../services/message-handler.service"
import { environment } from '../../../environments/environment';
import { loadStripe } from '@stripe/stripe-js';
import { LenguageService } from '../../@core/utils/lenguage.service'
import { User } from '../../@core/data/users';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import { NbToastrService, NbComponentStatus } from '@nebular/theme';


@Component({
  selector: 'ngx-plan-upgrade',
  templateUrl: './plan-upgrade.component.html',
  styleUrls: ['./plan-upgrade.component.scss']
})
export class PlanUpgradeComponent implements OnInit {
  user: User = <User>{};
  loading: boolean = false;
  openRedeem: boolean = false;
  couponCode: string;
  Paddle = (<any>window).Paddle;
  promotion: any;
  annually: boolean = true;
  //stripePromise = loadStripe(environment.stripeToken);
  constructor(
    private userService: UserService,
    private toastrService: NbToastrService,
    public language: LenguageService,
    private cd: ChangeDetectorRef
  ) {
    this.Paddle.Setup({ vendor: environment.paddle.vendor });
  }

  async ngOnInit() {
    this.init()
    this.userService.subscribeToUpdate().subscribe(data => {
      this.init()
    })
  }

  async init() {
    this.user = await this.userService.getLoggedUser();
    this.promotion = (await this.userService.getPromotions())[0]
    this.cd.detectChanges();
  }


  async checkout() {
    let product_id = (this.annually) ? environment.paddle.product_annually : environment.paddle.product
    this.Paddle.Checkout.open({
      product: product_id,
      email: this.user.email,
      passthrough: this.user.uid,
      successCallback: this.checkoutComplete,
      closeCallback: this.checkoutClosed
    });

  }


  checkoutClosed(data) {
    this.loading = false;
  }

  async checkoutComplete(data) {
    await sleep(3000);
    window.location.reload();

  }

  async redeem() {

    let res = <any> await this.userService.redeemCoupon(this.couponCode)
    this.user = <User>await this.userService.getCurrentUser();

    if(res.success){
      this.toastrService.success("Success! You now have lifetime access to Splitstack!","Splitstack 💖 AppSumo", {icon: "heart-outline", destroyByClick: true, duration: 30000})
    }

  }



  plans = {
    free: "🍝 Free",
    professional: "⚡ Professional",
  }

}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
